import { render, staticRenderFns } from "./invoice-recipient.vue?vue&type=template&id=d6084be2"
import script from "./invoice-recipient.vue?vue&type=script&lang=js"
export * from "./invoice-recipient.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports